import { map } from 'ramda'

export const csvFilenameFromQuery = (queryConfig) =>
  `drift_${queryConfig.metric.toLowerCase()}_${queryConfig.startDate}_${
    queryConfig.endDate
  }`

export const createCSV = (data: any[], filename: string) => {
  const csvData = map((rowArray) => rowArray.join(','), data).join('\r\n')
  createCSVDownload(csvData, filename)
}

export const createCSVDownload = (csvData: string, exportName = 'export') => {
  const blobData = new Blob([csvData], { type: 'text/csv' })
  const url = URL.createObjectURL(blobData)
  const encodedUri = encodeURI(url)
  downloadCSVInUI(encodedUri, exportName)
}

export const downloadCSVInUI = (encodedUri: string, exportName = 'export') => {
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${exportName}.csv`)
  document.body.appendChild(link) // Required for FF
  link.click()
}
